import * as excelJs from 'exceljs'
import {useEffect, useState} from 'react'
import {Button, Col, Container, Row} from 'react-bootstrap'
import {useNavigate, useParams} from 'react-router-dom'
import {KTCard, KTIcon} from '../../../../../_metronic/helpers'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {formatDateToDMY, formatISODateToDMYHM} from '../../../../helpers/dateFunctions'
import {getDocumentByIdUsuario} from '../../../../services/documentos'
import {downloadMultipleDocumentsIds} from '../../../../services/documentSent'
import {downloadFileS3, getFileInPDF} from '../../../../services/files'
import {showMessage} from '../../../../shared/Alerts'
import {useAuth2} from '../../../authv2/Auth2Provider'
import OverlayLoading from '../../../generales_component/OverlayLoading'
import {PartnersTableGeneral} from '../../../generales_component/PartnersTableGeneral'
import {handleS3Convert64} from '../../../generales_functions/files'
import {Doc} from '../../enviodocumento/enviodocumentInterface'
import {DocumentLoadDetailContext} from './DocumentLoadDetailContext'
import {DocumentQuickViewModal} from './DocumentQuickViewModal'
import {ShowFileModal} from './show-file-modal/ShowFileModal'
import { GoBackButton } from '../../../generales_component/GoBackButton'

const documentosBreadcrumbs = [
  {
    title: 'Hisrotial de Documentos',
    path: '/seguimiento/historialdocumentos',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const dataSelect = [
  {
    iconName: 'verify',
    title: 'Pendiente',
    stateName: 'pending',
    color: '#f39c12', // Orange
  },
  {
    iconName: 'security-user',
    title: 'Firmado',
    stateName: 'signed',
    color: '#2ecc71', // Green
  },
  {
    iconName: 'security-user',
    title: 'Observado',
    stateName: 'rejected',
    color: '#ff0000', // Red
  },
]

const HistorialDocumentDetail = () => {
  const [isHistorialDocumentDetailModalOpen, setHistorialDocumentDetailModalStatus] =
    useState(false)
  const [isDocumentQuickViewModalOpen, setDocumentQuickViewModalStatus] = useState(false)
  const [quickViewModalData, setQuickViewModalData] = useState<any>()
  const [loading, setLoading] = useState<boolean>(true)
  const [data, setData] = useState<any>()
  const [colaborador, setColaborador] = useState<any[]>([])
  const [listFiles, setListFiles] = useState<any[]>([])
  const [showFileModal, setShowFileModal] = useState(false)
  const [viewDocumento, setViewDocumento] = useState<Doc[]>([])
  const [indiceDocumento, setIndiceDocumento] = useState<number>(0)
  const [cargandoFile, setCargandoFile] = useState(false)
  const [checkedFiles, setCheckedFiles] = useState<string[]>([])
  const [pdfData, setPdfData] = useState<Doc[]>([])

  const {userData, selectedCompanyId} = useAuth2()

  const openHistorialDocumentDetailModal = () => {
    setHistorialDocumentDetailModalStatus(true)
  }

  const closeHistorialDocumentDetailModal = () => {
    setHistorialDocumentDetailModalStatus(false)
  }

  const openDocumentQuickViewModal = () => {
    setDocumentQuickViewModalStatus(true)
  }

  const closeDocumentQuickViewModal = () => {
    setDocumentQuickViewModalStatus(false)
  }

  const navigate = useNavigate()

  const {id} = useParams()

  const goBack = () => {
    navigate('/seguimiento/historialdocumentos')
  }

  useEffect(() => {
    if (id) {
      getDocument(id)
    }
  }, [])

  useEffect(() => {
    actualizarFiles()
  }, [checkedFiles])

  const getDocument = (id: string) => {
    getDocumentByIdUsuario(id, {})
      .then((response) => {
        if (response.success) {
          const DataNew = response.data.document.map((ele: any) => {
            return {...ele, check_selected: false}
          })
          setColaborador(response.data.colaborador)
          setListFiles(DataNew)
        } else {
          console.error(response.message)
        }
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleDocumentQuickViewModal = (file: any) => {
    setQuickViewModalData(file)
    openDocumentQuickViewModal()
  }

  const handleHistorialDocumentDetailModal = (file: any) => {
    setQuickViewModalData(file)
    openHistorialDocumentDetailModal()
  }

  const handleDownload = async (keyname: string, filename: string) => {
    const partes = filename.split('.')
    const extension = partes[partes.length - 1]

    downloadFileS3(keyname, extension)
      .then((response) => {
        if (response.success) {
          const link = document.createElement('a')
          link.href = response.data
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          showMessage('success', '¡Buen trabajo!', response.message)
        } else {
          console.log(response)
          showMessage('error', 'Hubo un error', response.error)
        }
      })
      .catch((error) => {
        console.log(error)
        showMessage('error', 'Hubo un error', error.message)
      })
  }

  const headerDocumentsUser = [
    {
      type: 'check',
      field: 'check_selected',
      label: 'Seleccionar',
    },
    {
      type: 'string',
      field: 'name',
      label: 'Documentos',
    },
    {
      type: 'date',
      field: 'createdAt',
      label: 'Fecha de Emisión',
    },
    {
      type: 'date',
      field: 'updatedAt',
      label: 'Fecha de última acción',
    },
    {
      type: 'button',
      field: 'state',
      icon: 'fingerprint-scanning',
      btn: {
        pending: 'btn-light-warning',
        signed: 'btn-light-success',
        rejected: 'btn-light-danger',
      },
      variantTooltip: {
        pending: 'warning',
        signed: 'success',
        rejected: 'error',
      },
      title: {
        pending: 'Pendiente',
        signed: 'Firmado',
        rejected: 'Observado',
      },
      descripcion: 'rejectionMessage',
      label: 'Estado',
    },
    {
      type: 'button',
      field: 'show',
      icon: 'eye',
      btn: 'btn-light-primary',
      label: 'Ver',
    },
    {
      type: 'button',
      field: 'donwload',
      icon: 'cloud-download',
      btn: 'btn-light-primary',
      label: 'Descargar',
    },
  ]
  /* const listFiles: { [key: string]: any }[] = [] */

  const handleBtnSelected = async (item: any, array: any[], accion: string, propList: string) => {
    const arrayNew: any[] = []
    let TypeSelected = ''
    if (accion === 'delete') {
      array.forEach((dat: any) => {
        let entro = false
        if (dat['_id'] === item._id) {
          entro = true
        }
        if (!entro) {
          arrayNew.push(dat)
        }
      })
    } else if (accion === 'donwload') {
      let fileName = ''
      setCargandoFile(true)
      if (item.typeSelected === 'Configurado') {
        const partes = item.keyname.split('.')
        const extension = partes[partes.length - 1]
        fileName = `${item.name}.${extension}`
      } else {
        fileName = item.name
      }
      downloadFileS3(item.keyname, fileName)
        .then((response) => {
          if (response.success) {
            const link = document.createElement('a')
            link.href = response.data
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            setCargandoFile(false)

            showMessage('success', '¡Buen trabajo!', response.message)
          } else {
            console.log(response)
            showMessage('error', 'Hubo un error', response.error)
          }
        })
        .catch((error) => {
          setCargandoFile(false)
          console.log(error)
          showMessage('error', 'Hubo un error', error.message)
        })
    } else if (accion === 'show') {
      if (item.typeSelected) {
        TypeSelected = item.typeSelected
      }
      setCargandoFile(true)
      const newViewDocument: any[] = []
      let indice = 0

      for await (const dat of listFiles) {
        let fileName = ''
        if (dat.typeSelected === 'Configurado') {
          const partes = dat.keyname.split('.')
          const extension = partes[partes.length - 1]
          fileName = `${dat.name}.${extension}`
        } else {
          fileName = dat.name
        }
        if (dat.keyname) {
          if (String(item._id) === String(dat._id)) {
            setIndiceDocumento(indice)
          }

          const partes = dat.keyname.split('.')
          const extension = partes[partes.length - 1]
          if (extension === 'pdf') {
            const result = await handleS3Convert64(dat.keyname, fileName)
            if (result) {
              newViewDocument.push({
                uri: result.uri,
                fileType: result.fileType,
                fileName: result.fileName,
                keyName: dat.keyname,
              })
              indice++
            }
          } else {
            let newNamePartes = fileName.split('.')
            newNamePartes[newNamePartes.length - 1] = 'pdf'
            const newFileName = newNamePartes.join('.')
            const result = await getFileInPDF(dat.keyname)
            if (result) {
              newViewDocument.push({
                uri: result.data,
                fileType: 'pdf',
                fileName: newFileName,
                keyName: dat.keyname,
              })
              indice++
            }
          }
        }
      }
      setCargandoFile(false)
      setViewDocumento(newViewDocument)
      setShowFileModal(true)

      // }
    } else if (accion === 'edit') {
      if (item.typeSelected) {
        TypeSelected = item.typeSelected
      }
    }
  }

  const handleBtnExport = async (accion: string) => {
    if (accion === 'Report') {
      const columns: {field: string; label: string}[] = [
        {
          field: 'empresa',
          label: 'EMPRESA',
        },
        {
          field: 'dni',
          label: 'DNI',
        },
        {
          field: 'fechaIngreso',
          label: 'FECHA DE INGRESO',
        },
        {
          field: 'apellido_paterno',
          label: 'APELLIDO PATERNO',
        },
        {
          field: 'apellido_materno',
          label: 'APELLIDO MATERNO',
        },
        {
          field: 'nombres',
          label: 'NOMBRES COMPLETOS',
        },
        {
          field: 'cargo',
          label: 'CARGO',
        },
        {
          field: 'nameDocument',
          label: 'NOMBRE DE DOCUMENTO',
        },
        {
          field: 'fechaEnvio',
          label: 'FECHA DE ENVIO',
        },
        {
          field: 'fechaFirma',
          label: 'FECHA DE FIRMA',
        },
        {
          field: 'estado',
          label: 'ESTADO',
        },
        {
          field: 'descripcion',
          label: 'DESCRIPCIÓN',
        },
      ]

      const DataExport: any[] = []
      listFiles.forEach((file) => {
        let exist = false
        checkedFiles.forEach((_id) => {
          if (String(file._id) === String(_id)) {
            exist = true
          }
        })
        if (exist) {
          const empresa = userData?.userCompany?.find((n: any) => n.id === selectedCompanyId).label

          const partes = file.keyname.split('.')
          const extension = partes[partes.length - 1]
          const partesname = file.name.split('.')
          let filename = ''
          partesname.forEach((par: string, i: number) => {
            if (String(extension) !== String(par)) {
              i === 0
                ? (filename += filename + String(par))
                : (filename += filename + '.' + String(par))
            }
          })

          DataExport.push({
            fechaIngreso: formatDateToDMY(colaborador[0].fechaIngreso),
            dni: colaborador[0].dni,
            empresa: empresa,
            apellido_paterno: colaborador[0].apellido_pat,
            apellido_materno: colaborador[0].apellido_mat,
            nombres: colaborador[0].nombres,
            cargo: colaborador[0].cargo,
            nameDocument: filename,
            fechaEnvio: formatDateToDMY(file.createdAt),
            fechaFirma: file.updatedAt !== null ? formatDateToDMY(file.updatedAt) : '',
            estado: file.state.toUpperCase(),
            descripcion: file.rejectionMessage,
          })
        }
      })
      if (DataExport.length > 0) {
        exportExcelJS(columns, DataExport)
      } else {
        showMessage(
          'info',
          'Seleccionar Documento',
          'Seleccionar por lo menos 1 documento que desea exportar'
        )
      }
    } else if (accion === 'File') {
      if (checkedFiles.length > 0) {
        setCargandoFile(true)
        downloadMultipleDocumentsIds({Ids: checkedFiles})
          .then((response) => {
            setCargandoFile(false)
            if (response.success) {
              const link = document.createElement('a')
              link.href = response.data
              link.download = 'detalle_historial_document'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)

              showMessage('success', '¡Buen trabajo!', response.message)
            } else {
              console.log(response)
              showMessage('error', 'Hubo un error', response.error)
            }
          })
          .catch((error) => {
            setCargandoFile(false)
            console.log(error)
            showMessage('error', 'Hubo un error', error.message)
          })
      } else {
        showMessage(
          'info',
          'Seleccionar Documento',
          'Seleccionar por lo menos 1 documento que desea exportar'
        )
      }
    }
  }

  const handleCheckSelected = (_ids: string[], check?: boolean) => {
    const arraySelected: string[] = []
    checkedFiles.forEach((id) => {
      arraySelected.push(id)
    })

    if (_ids.length === 1) {
      if (arraySelected.includes(_ids[0])) {
        const indiceAEliminar = arraySelected.indexOf(_ids[0])
        arraySelected.splice(indiceAEliminar, 1)
        setCheckedFiles(arraySelected)
      } else {
        arraySelected.push(_ids[0])
        setCheckedFiles(arraySelected)
      }
    } else {
      const arrayBody: any[] = []
      if (check) {
        setCheckedFiles(_ids)
      } else {
        setCheckedFiles([])
      }
    }
  }

  const exportExcelJS = (columns: {field: string; label: string}[], dataExport: any[]) => {
    const workbook = new excelJs.Workbook()
    const worksheet = workbook.addWorksheet()
    const base64Logo =
      'data:image/png;base64,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'

    // Adding Title
    worksheet.mergeCells('C1', 'F4')
    const titleRow = worksheet.getCell('C1')
    titleRow.value = 'REPORTE DETALLE DE DOCUMENTOS POR USUARIO'
    titleRow.font = {
      name: 'Calibri',
      size: 12,
      bold: true,
      color: {argb: '00B050'},
    }
    titleRow.alignment = {vertical: 'middle', horizontal: 'center'}

    // Adding Date
    worksheet.mergeCells('G1:H4')
    const datenew = new Date()
    const date = formatDateToDMY(datenew)
    const dateCell = worksheet.getCell('G1')
    dateCell.value = date
    dateCell.font = {
      name: 'Calibri',
      size: 12,
      bold: true,
    }
    dateCell.alignment = {vertical: 'middle', horizontal: 'center'}

    // Adding Logo
    const myLogoImage = workbook.addImage({
      base64: base64Logo,
      extension: 'png',
    })
    worksheet.mergeCells('A1:B4')
    worksheet.addImage(myLogoImage, {
      tl: {col: 0.6, row: 0},
      ext: {width: 120, height: 68},
    })

    // Adding Header Row
    const header = columns.map((el) => el.label)
    const headerKeys = columns.map((el) => ({key: el.field}))
    const headerRow = worksheet.addRow(header)
    worksheet.columns = headerKeys
    headerRow.eachCell((cell) => {
      cell.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true,
      }
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: '18B86E'},
        bgColor: {argb: ''},
      }
      cell.font = {
        color: {argb: 'FFFFFF'},
        size: 9,
        bold: true,
      }
    })
    headerRow.height = 35
    worksheet.autoFilter = {
      from: {
        row: headerRow.number,
        column: 1,
      },
      to: {
        row: headerRow.number,
        column: header.length,
      },
    }

    const dataTableTemplate = dataExport

    dataTableTemplate.forEach((dataRow: any) => {
      const row = worksheet.addRow(dataRow)
      row.alignment = {
        vertical: 'middle',
        horizontal: 'left',
        wrapText: true,
      }
      row.eachCell({includeEmpty: true}, (cell) => {
        cell.font = {
          color: {argb: '000000'},
          size: 9,
        }
      })
    })

    if (worksheet.columns) {
      worksheet.columns.forEach(function (column) {
        if (column) {
          let dataMax = 0
          column.eachCell &&
            column.eachCell({includeEmpty: true}, function (cell, idx) {
              const columnLength = cell.value ? String(cell.value).length : 0
              if (columnLength > dataMax) {
                dataMax = columnLength
              }
            })
          if (column) {
            column.width = dataMax < 15 ? 15 : dataMax
          }
        }
      })
    }

    worksheet.addRows([{}, {}, {}])

    const footerRow = worksheet.addRow([
      `Reporte Generado desde WDOCS | ${formatISODateToDMYHM(datenew)}`,
    ])
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {argb: '18C073'},
    }
    footerRow.getCell(1).font = {
      color: {argb: 'FFFFFF'},
      size: 12,
      bold: true,
    }

    // Merge Cells
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`)

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'detalle_reporte_historial_usuario.xlsx'
      a.click()
    })
  }

  const actualizarFiles = () => {
    const newArray: any[] = listFiles.map((r) => {
      let exist = false
      checkedFiles.forEach((_id) => {
        if (String(r._id) === String(_id)) {
          exist = true
        }
      })
      if (exist) {
        return {...r, check_selected: true}
      } else {
        return {...r, check_selected: false}
      }
    })
    setListFiles(newArray)
  }

  console.log(colaborador)
  return (
    <DocumentLoadDetailContext.Provider
      value={{
        isHistorialDocumentDetailModalOpen,
        openHistorialDocumentDetailModal,
        closeHistorialDocumentDetailModal,
        isDocumentQuickViewModalOpen,
        openDocumentQuickViewModal,
        closeDocumentQuickViewModal,
        quickViewModalData,
        data,
        showFileModal,
        setShowFileModal,
        viewDocumento,
        setViewDocumento,
        indiceDocumento,
        setIndiceDocumento,
      }}
    >
      <PageTitle breadcrumbs={documentosBreadcrumbs}>
        {`Detalle de Documentos del usuario: ${colaborador[0]?.nombres ?? ''} ${
          colaborador[0]?.apellidos ?? ''
        } - ${colaborador[0]?.dni ?? ''}`}
      </PageTitle>
      <GoBackButton goBack={goBack} />
      <KTCard>
        <div className='pt-3 pb-6'>
          <Container>
            <Row className='mb-2'>
              <Col sm>
                <PartnersTableGeneral
                  key={'table_general1'}
                  title={'Documentos'}
                  searchVisible={true}
                  searchCol={4}
                  rangeDateVisible={true}
                  rangeDateCol={5}
                  filterKeyDate={['updatedAt']}
                  rangeDateTitulo={'Rangos de Fecha de Búsqueda'}
                  searchHint={'Buscar por documento ...'}
                  filterSelect={true}
                  filterSelectCol={3}
                  filterKeySelect={['state']}
                  dataSelect={dataSelect}
                  dataSelectTitulo={'Estado'}
                  theaderVisible={true}
                  theader={headerDocumentsUser}
                  tbody={listFiles}
                  tMaxHeight={'600px'}
                  onCheckSelected={(_id: string[], check?: boolean) =>
                    handleCheckSelected(_id, check)
                  }
                  onBtnSelected={(Item: any, accion: string) =>
                    handleBtnSelected(Item, listFiles, accion, 'Users')
                  }
                  onBtnExport={(accion: string) => handleBtnExport(accion)}
                  classTable='table-rounded table-striped border'
                />
              </Col>
            </Row>
          </Container>
        </div>
      </KTCard>
      {cargandoFile && <OverlayLoading />}
      <DocumentQuickViewModal />
      <ShowFileModal />
    </DocumentLoadDetailContext.Provider>
  )
}
export {HistorialDocumentDetail}
